// DS: i4.35
import React from 'react';
import IconWrap from '../../IconWrap';
const CommissionBrush = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "16",
        height: "16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m10.185 6.411-1.096-1.02c-1.075-1.916 1.293-4.462 4.75-3.47.185.052.223.291.068.405-.327.24-.713.723-.76 1.67-.093 1.903-1.417 3.333-2.962 2.415ZM9.212 6.929c.584.587.609 1.863.056 2.412-1.917 1.511-6.317 4.97-6.314 4.968l-.003.001c-.228.11-.588 0-.869-.28-.267-.267-.379-.607-.295-.835 0 0 3.752-4.752 5.012-6.335.553-.55 1.828-.518 2.413.069Z"
    })));
CommissionBrush.displayName = 'CommissionBrush';
export default CommissionBrush;
